var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C29B40",
    d: "M17.74 3.5H6.26A4.26 4.26 0 0 0 2 7.76v8.48a4.26 4.26 0 0 0 4.26 4.26h11.48A4.26 4.26 0 0 0 22 16.24V7.76a4.26 4.26 0 0 0-4.26-4.26",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C29B40",
    d: "M12 13a3.44 3.44 0 0 1-2.18-.79L6.42 9.4a.762.762 0 0 1 1-1.15l3.38 2.81a1.91 1.91 0 0 0 2.46 0l3.29-2.79a.74.74 0 0 1 1 .08.76.76 0 0 1-.08 1.06l-3.29 2.79A3.4 3.4 0 0 1 12 13"
  })));
};
export default SvgEmail;